import { Component, ChangeDetectionStrategy } from '@angular/core';
import { RouterLink } from '@angular/router';
import { ButtonComponent } from '@fc-shared/ui/buttons/button.component';
import { NotFoundPreviewComponent } from '@fc-core/containers/page-not-found/not-found-preview.component';

@Component({
  selector: 'fc-page-not-found',
  host: {
    class:
      'flex min-h-dvh w-full flex-col items-center justify-center gap-20 p-24 text-center lg:flex-row lg:gap-150 lg:text-left',
  },
  template: `
    <div class="flex flex-col items-center lg:items-start">
      <div
        class="text-[120px] font-semibold leading-none text-primary-500 lg:text-[240px]"
      >
        404
      </div>
      <div class="mb-24 text-3xl font-semibold text-primary-950 lg:text-4xl">
        Page not found
      </div>
      <p class="mb-48 text-base text-grey-400 lg:text-lg">
        This page is missing or you assembled the link incorrectly
      </p>
      <fc-button [routerLink]="['/']">Go to Homepage</fc-button>
    </div>

    <fc-not-found-preview class="block w-full max-w-474 lg:w-474 lg:shrink-0" />
  `,
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [RouterLink, ButtonComponent, NotFoundPreviewComponent],
})
export class PageNotFoundComponent {}
